import { Radio } from 'lucide-react';

interface WeeklyEchoProps {
  text: string;
  isLoading?: boolean;
}

export default function WeeklyEcho({ text, isLoading = false }: WeeklyEchoProps) {
  return (
    <div className="bg-[#181818] rounded-2xl p-5 border border-[#282828]" style={{ boxShadow: '0px 12px 28px 3px rgba(0, 0, 0, 0.52), 0px 2px 8px 1px rgba(0, 0, 0, 0.16), inset 0px 1px 1px rgba(255, 255, 255, 0.04), inset 0px -1px 2px rgba(0, 0, 0, 0.22)' }}>
      <div className="flex items-center gap-2 mb-2">
        <Radio className="w-3.5 h-3.5 text-[#40E0D0]" />
        <h3 className="text-[13px] font-semibold text-[#F5F5F5]">
          Your Weekly Theme
        </h3>
      </div>
      {isLoading ? (
        <div className="h-10 bg-[#111111] rounded animate-pulse" />
      ) : (
        <p className="text-[12px] text-[#A0A0A0] leading-relaxed" style={{ lineHeight: '1.5' }}>
          {text}
        </p>
      )}
    </div>
  );
}
